import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const SLMPreset = definePreset(Aura, {
  primitive: {
    blue: {
      50: '#eff7ff',
      100: '#dbeefe',
      200: '#bfe2fe',
      300: '#92d1fd',
      400: '#5eb8fa',
      500: '#047fe5', // brand primary
      600: '#0a6bc9', // hover
      700: '#0f55a3',
      800: '#10467C',
      900: '#0D3966',
      950: '#0A2B4D',
    },
  },

  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
  extend: {
    custom: {
      brand: {
        blueStart: '#1976D2',
        blueEnd: '#10467C',
        accentBlue: '#2853ea',
      },
      font: {
        family: 'Inter, sans-serif',
      },
    },
  },

  css: ({ dt }) => `
    :root {
      --brand-blue-start: ${dt('custom.brand.blueStart')};
      --brand-blue-end: ${dt('custom.brand.blueEnd')};
      --accent-blue: ${dt('custom.brand.accentBlue')};
      --font-family: ${dt('custom.font.family')};
    }
  `,
});
